import { render, staticRenderFns } from "./HistoryCreateMoney.vue?vue&type=template&id=30b0c173&"
import script from "./HistoryCreateMoney.vue?vue&type=script&lang=js&"
export * from "./HistoryCreateMoney.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports